// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__UzDrK","approved":"Status_approved__3KKEw","rejected":"Status_rejected__2CD_y","expired":"Status_expired__2RNeR","label":"Status_label__3Y951"};